import React from 'react';
import classNames from 'classnames';
import styles from './AssetWrapper.module.scss';

interface AssetWrapperProps {
	className?: string;
	fixedRatio?: boolean;
	aspectRatio?: string;
	children: React.ReactElement;
}

/**
 * Component used for wrapping assets, its children will be 100% of width & height of parent,
 * and can optionally get a fixed aspect ratio. It either needs aspect ratio or fixed size specified
 * (size with contextual styling via className prop), otherwise it won't have a height.
 * Default fixed ratio is 16:9, but it can be overridden by using 'aspectRatioX' and 'aspectRatioY'.
 */
export const AssetWrapper: React.FunctionComponent<AssetWrapperProps> = ({
	className,
	fixedRatio,
	aspectRatio = '16/9',
	children,
}) => {
	return (
		<div
			className={classNames(styles.wrapper, { [styles.hasFixedRatio]: fixedRatio || aspectRatio }, className)}
			style={{ '--aspect-ratio': aspectRatio } as React.CSSProperties}
		>
			{React.cloneElement(children, {
				className: classNames(children.props.className, styles.asset),
			})}
		</div>
	);
};
